var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DropdownNationalHubsLayout',{attrs:{"links":_vm.jobCategoriesTransformed,"max-column-items":5,"drop-down-title":"Most Popular Jobs"}})}
var staticRenderFns = []

export { render, staticRenderFns }